import GetCompanyForUserRequestModelBase from '../_generated/modelBases/get-company-for-user-request-model-base';

export default class GetCompanyForUserRequestModel extends GetCompanyForUserRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
